import React from 'react';
import Navbar from '../../components/Layouts/Navbar';
import Footer from '../../components/Layouts/Footer';
import PageSeo from '../../components/Common/PageSeo';
import SubscribeStyleOne from '../../components/Common/SubscribeStyleOne';
import ZeroTrustVpnHeader from '../../components/ManagedServices/ZeroTrustVpn/ZeroTrustVpnHeader';
import ZeroTrustVpnBenefits from '../../components/ManagedServices/ZeroTrustVpn/ZeroTrustVpnBenefits';
import ZeroTrustVpnIncluded from '../../components/ManagedServices/ZeroTrustVpn/ZeroTrustVpnIncluded';
import ZeroTrustVpnAudiences from '../../components/ManagedServices/ZeroTrustVpn/ZeroTrustVpnAudiences';
import ZeroTrustVpnProcess from '../../components/ManagedServices/ZeroTrustVpn/ZeroTrustVpnProcess';
import ZeroTrustVpnTrust from '../../components/ManagedServices/ZeroTrustVpn/ZeroTrustVpnTrust';
import ZeroTrustVpnPricing from '../../components/ManagedServices/ZeroTrustVpn/ZeroTrustVpnPricing';
import ZeroTrustVpnFaq from '../../components/ManagedServices/ZeroTrustVpn/ZeroTrustVpnFaq';
import ZeroTrustVpnCta from '../../components/ManagedServices/ZeroTrustVpn/ZeroTrustVpnCta';
import ManagedServicesBlogPosts from '../../components/ManagedServices/ManagedServicesBlogPosts';
import { fetchBlogPostsForZeroTrustVpn } from '../../lib/blogApi';
import { useTranslations } from '../../locales/useTranslations';
import { useRouter } from 'next/router';

const ManagedServicesZeroTrustVpnPage = ({ relatedBlogPosts = [] }) => {
  const { t } = useTranslations();
  const { locale } = useRouter();
  const baseUrl = locale === 'en' ? 'https://simplify-data.com' : 'https://simplify-data.de';

  return (
    <>
      <PageSeo
        title={t('managedServices_zeroTrustVpn_page_title')}
        description={t('managedServices_zeroTrustVpn_page_description')}
        canonical={`${baseUrl}/managed-services/zerotrustvpn/`}
        openGraph={{
          url: `${baseUrl}/managed-services/zerotrustvpn/`,
          title: t('managedServices_zeroTrustVpn_page_title'),
          description: t('managedServices_zeroTrustVpn_page_description'),
          images: [
            {
              url: `${baseUrl}/images/simplify-data.png`,
              width: 1200,
              height: 1200,
              alt: t('managedServices_zeroTrustVpn_header_title'),
              type: 'image/jpeg',
            },
          ],
          siteName: 'Simplify Data',
          locale: locale === 'en' ? 'en_US' : 'de_DE',
          type: 'website',
        }}
        additionalMetaTags={[
          {
            name: 'keywords',
            content: t('managedServices_zeroTrustVpn_page_keywords'),
          },
        ]}
        additionalLinkTags={[
          {
            rel: 'alternate',
            hrefLang: 'de',
            href: 'https://simplify-data.de/managed-services/zerotrustvpn/',
          },
          {
            rel: 'alternate',
            hrefLang: 'en',
            href: 'https://simplify-data.com/managed-services/zerotrustvpn/',
          },
        ]}
      />
      <Navbar />
      <ZeroTrustVpnHeader />
      <ZeroTrustVpnBenefits />
      <ZeroTrustVpnIncluded />
      <ZeroTrustVpnAudiences />
      <ZeroTrustVpnProcess />
      <ZeroTrustVpnTrust />
      <ZeroTrustVpnPricing />
      <ZeroTrustVpnFaq />
      <ZeroTrustVpnCta />
      <ManagedServicesBlogPosts
        posts={relatedBlogPosts}
        badgeKey="managedServices_zeroTrustVpn_blog_badge"
        titleKey="managedServices_zeroTrustVpn_blog_title"
        subtitleKey="managedServices_zeroTrustVpn_blog_subtitle"
        ctaKey="managedServices_zeroTrustVpn_blog_cta"
      />
      <SubscribeStyleOne />
      <Footer />
    </>
  );
};

export default ManagedServicesZeroTrustVpnPage;

export async function getStaticProps({ locale }) {
  try {
    const relatedBlogPosts = await fetchBlogPostsForZeroTrustVpn(locale || 'de', 6);
    return {
      props: { relatedBlogPosts },
      revalidate: 3600,
    };
  } catch {
    return {
      props: { relatedBlogPosts: [] },
      revalidate: 600,
    };
  }
}
